import './Shop.scss'

import React, { Component } from 'react'
import moment from 'moment'
import { connect } from 'react-redux';
import RangeSelector from '../components/RangeSelector';
import { push } from 'connected-react-router'
import { arrayToObject } from '../helper'
import { Link } from 'react-router-dom';
import { Input, Button, Label, Textarea, Select } from '../components'

import { PaymentOptions } from '../components'

import * as actions from '../actions'


import './OrderPage.scss';

class OrderPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            voucher_description: '',
            ref_id: null,
            voucher_code: '',
            voucher_amount: '',
            voucher_given: '',
            code_error_message: false,
            voucher_valide: false,
            validate_visabile: false,
            new_amount: '',
            type: ''
        }
    }

    renderAttributes() {
        const props = this.props

        if (props.orderType === "voucher") {
            return <dl className="attribute-list">
                <dt className="attribute-list-name">Art:</dt>
                <dd className="attribute-list-value">Gutschein</dd>
                <dt className="attribute-list-name">Betrag:</dt>
                <dd className="attribute-list-value">{props.voucherAmount.toFixed(2)} €</dd>
                <dt className="attribute-list-name">Name:</dt>
                <dd className="attribute-list-value">{props.voucherName}</dd>
                <dt className="attribute-list-name">Persönliche Nachricht:</dt>
                <dd className="attribute-list-value">{props.voucherText}</dd>
            </dl>
        }

        return <dl className="attribute-list">
            <dt className="attribute-list-name">Art:</dt>
            <dd className="attribute-list-value">{props.trainingType.name}</dd>
            <dt className="attribute-list-name">Dauer:</dt>
            <dd className="attribute-list-value">{props.trainingType.shopDuration}</dd>
            <dt className="attribute-list-name">Datum:</dt>
            <dd className="attribute-list-value">{moment(props.training.date).format('D. MMMM YYYY')}</dd>
            <dt className="attribute-list-name">Beginn:</dt>
            <dd className="attribute-list-value">{props.training.startAt.substring(0, 5)}</dd>
            <dt className="attribute-list-name">Ende:</dt>
            <dd className="attribute-list-value">{props.training.endAt.substring(0, 5)}</dd>
            <dt className="attribute-list-name">Teilnehmer:</dt>
            <dd className="attribute-list-value">{props.participants.length}</dd>
        </dl>
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    getPrice() {
        const props = this.props;
        if (props.orderType == "voucher") {
            return props.voucherAmount
        }

        return props.training.price * props.participants.length
    }

    validateVoucher() {

    }

    checkVoucher() {
        actions.loadVoucherStatus(this.getPrice(), this.state.voucher_code)
            .then(data => this.props.onDiscountChanged({
                voucher_amount: data.voucher_amount,
                voucher_valide: data.voucher_valide,
                type: data.type,
                ref_id: data.ref_id,
                voucher_description: data.voucher_description,
                voucher_code: this.state.voucher_code
            }))

        if (this.props.discount.voucher_valide) {
            this.setState({ validate_visabile: true })
            this.setState({ code_error_message: false })
            const old_price = this.getPrice()
            if (old_price - this.props.discount.voucher_amount < 0) {
                this.setState({ new_amount: 0 })
                this.setState({ voucher_given: old_price })
            }
            else if (this.props.discount.voucher_amount === 0) {
                this.setState({ new_amount: old_price })
                this.setState({ voucher_given: 0 })
                this.setState({ voucher_description: "Kein Guthaben Mehr" })
            }
            else {
                this.setState({ new_amount: old_price - this.props.discount.voucher_amount })
                this.setState({ voucher_given: this.props.discount.voucher_amount })
            }

        } else {
            this.setState({ voucher_valide: false })
            this.setState({ code_error_message: true })
        }
        console.log(this.props.discount);
    }

    render() {
        const props = this.props;
        if (props.loading)
            return null

        let price = this.getPrice();
        const net = price / 1.1900;
        const invoiceInfo = props.invoiceInfo

        return (
            <article className={"shop-page page"}>
                <form onSubmit={props.submitOrder}>
                    <section className="section gray-section on-screen">
                        <div className="section-content">
                            <div className="container">
                                <h1 className="text-center shop-title">Bestellung</h1>
                                <div className="shop">
                                    <div className="shop-content">
                                        <div className="shop-content-box">
                                            <h2 className="shop-content-box-title">Fahrsicherheitstraining</h2>
                                            <div>
                                                {this.renderAttributes()}
                                                <Link to="/" className="order-edit-link">bearbeiten</Link>
                                                <div className="order-hint">
                                                    <strong>Hinweis:</strong> Für Beifahrer berechnen wir € 25,00 brutto. Diese Gebühr wird im Falle einer Buchung zum PKW Training innerhalb der folgenden 12 Monate gutgeschrieben.
                                                </div>
                                            </div>
                                        </div>
                                        {props.orderType !== "voucher" && (
                                            <div className="shop-content-box">
                                                <h2 className="shop-content-box-title">Teilnehmerinformationen</h2>
                                                <ol className="slot-list">
                                                    {props.participants.map((item, i) => (
                                                        <li key={i} className="slot-list-item">
                                                            {item.firstName} {item.lastName} <br /> Alter: {item.age}
                                                        </li>
                                                    ))}
                                                </ol>
                                                <Link to="/" className="order-edit-link">bearbeiten</Link>
                                            </div>
                                        )}
                                        <div className="shop-content-box">
                                            <h2 className="shop-content-box-title">Zahlungsweise</h2>
                                            <PaymentOptions paymentOption={props.paymentOption} onChange={(paymentOption) => {
                                                props.onPaymentMethodChanged(paymentOption)
                                            }} />
                                        </div>
                                        <div className="shop-content-box">

                                            <br />
                                            <label>
                                                <input type="checkbox" required className="radio-input radio-input--red" required />
                                                <small>Ich habe die <a href="/agb" target="_blank">AGB</a> zur Kenntnis genommen und ich bin einverstanden.</small>
                                            </label>
                                            <br />
                                            <label>
                                                <input type="checkbox" required className="radio-input radio-input--red" required />
                                                <small>Ich habe die <a href="/datenschutzbestimmungen" target="_blank">Datenschutzbelehrung</a> zur Kenntnis genommen.</small>
                                            </label>
                                        </div>
                                        {this.state.externalVoucher && (
                                            <div className="shop-content-box">
                                                <h2 className="shop-content-box-title">Hinweis:</h2>
                                                <p>
                                                    Sie möchten einen Gutschein der Berufsgenossenschaft einlösen.
                                                    Bitte wenden Sie sich direkt an unser Team.
                                                </p>
                                                <p>
                                                    Telefon: <a href="tel:+492843991955">02843 - 99 19 55</a><br />
                                                    E-Mail: <a href="mailto:info@fahrsicherheitscentrum.de?subject=Kontakt" data-letters="info@fahrsicherheitscentrum.de"><span class="s1">info@fahrsicherheitscentrum.de</span></a>
                                                </p>
                                            </div>
                                        )}
                                        <p className="button-bar">
                                            {!this.state.externalVoucher && (
                                                <button type="submit" className="btn white-btn" style={{ float: 'right' }} disabled={props.blocked} onClick={() => this.checkVoucher()}>
                                                    {props.blocked && 'bitte warten'}
                                                    {!props.blocked && 'kostenpflichtig Bestellen'}
                                                </button>
                                            )}
                                            <button type="button" className="btn white-btn" onClick={() => this.props.prev()}>Zurück</button>
                                        </p>
                                    </div>
                                    <div className="shop-sidebar shop-sidebar--order">
                                        <h2 className="shop-sidebar-title">Rechnungsinformationen</h2>
                                        <div>
                                            {invoiceInfo.salutation === 'mr' ? 'Herr' : 'Frau'} {invoiceInfo.firstName} {invoiceInfo.lastName} <br />
                                            {invoiceInfo.company && (<div>{invoiceInfo.company}</div>)}
                                            {invoiceInfo.street} {invoiceInfo.housenumber}<br />
                                            {invoiceInfo.zipCode} {invoiceInfo.city}<br />
                                            {invoiceInfo.email}<br />
                                            {invoiceInfo.phone}
                                        </div>

                                        <Link to="/" className="order-edit-link">bearbeiten</Link>

                                        <table className="invoice-table" style={{ width: '100%' }}>
                                            <tbody className="invoice-table-items">
                                                {props.orderType !== "voucher" && props.participants.map((item, i) => (
                                                    <tr key={i}>
                                                        <th>Teilnehmer {i + 1}</th>
                                                        <td className="text-right">{props.training.price.toFixed(2)} €</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tbody className="invoice-table-subtotals">
                                                <tr>
                                                    <th>Netto:</th>
                                                    <td className="text-right">{net.toFixed(2)} €</td>
                                                </tr>
                                                <tr>
                                                    <th>MwSt:</th>
                                                    <td className="text-right">{(price - net).toFixed(2)} €</td>
                                                </tr>
                                            </tbody>
                                            <tfoot className="invoice-table-totals">
                                                <tr>
                                                    <th>Gesamtsumme:</th>
                                                    <td className="text-right">{price.toFixed(2)} €</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                        <div className="spacer">
                                            <div> <strong> Gutscheincode einlösen: </strong></div>
                                            <input className="input-voucher-code" name="voucher_code" placeholder="Gutscheincode" value={this.state.voucher_code} onChange={(e) => this.handleChange(e)} />
                                            {this.state.code_error_message && <div> Bitte Prüfen Sie nochmal. </div>}
                                            {this.state.validate_visabile && <div> <strong> Sie Benutzen: </strong></div>}
                                            {this.state.validate_visabile && <div >{this.props.discount.voucher_description}</div>}
                                            {this.state.validate_visabile && <div> <strong> Gewährter Rabatt: </strong></div>}
                                            {this.state.validate_visabile && <div >{this.state.voucher_given.toFixed(2)} €</div>}
                                            {this.state.validate_visabile && <div> <strong> Neue Gesamtsumme: </strong></div>}
                                            {this.state.validate_visabile && <div >{this.state.new_amount.toFixed(2)} €</div>}
                                            <button type="button" className="btn voucher yellow-btn" onClick={() => this.checkVoucher()}>Prüfen</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </form>
            </article>
        )
    }
}

const mapStateToProps = state => {
    const training = state.order.trainingId
        && state.shop.trainings
        && arrayToObject(state.shop.trainings, 'id')[state.order.trainingId]
    return {
        blocked: state.shop.blocked,
        loading: state.shop.loading,
        paymentOption: state.order.paymentOption,
        discount: state.order.discount,
        participants: state.order.participants,
        training: training,
        orderType: state.order.type,
        voucherAmount: state.order.voucherAmount,
        voucherText: state.order.voucherText,
        voucherName: state.order.voucherName,
        trainingType: training && state.shop.trainingTypes[training.trainingTypeId],
        invoiceInfo: state.order.invoiceInfo
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        submitOrder: (e) => {
            e.preventDefault();
            dispatch(actions.submitOrder())
        },
        onPaymentMethodChanged: (params) => dispatch({ type: 'ORDER_PAYMENT_OPTION_CHANGED', paymentOption: params }),
        onDiscountChanged: (params) => dispatch({ type: 'ORDER_DISCOUNT_CHANGED', discount: params }),
        prev: (orderType) => {
            if (orderType == "voucher") {
                dispatch(push('/bestellung/rechnungsinformationen'))
            } else {
                dispatch(push('/bestellung/teilnehmer'))
            }
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderPage)



// WEBPACK FOOTER //
// ./src/pages/OrderPage.jsx